import logo from './logo.svg';
import './App.css';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Index from './Component/Index';
import { BrowserRouter, Route, Routes } from 'react-router';
import Properties from './Component/Properties';
import PropertyDetails from './Component/PropertyDetails';
import Contact from './Component/Contact';
import Register from './Component/Register';
import Login from './Component/Login';
import { createContext, use, useState } from 'react';
export const LoginContext = createContext();

function App() {

  const [login,setLogin] = useState(false)
  return (
    <>
      <LoginContext.Provider value={{ login,setLogin }}>
        <BrowserRouter>
          <Header/>
            <Routes>
              <Route path='/' element={<Index/>}></Route>
              <Route path='properties' element={<Properties/>}>
                <Route path='propertydetails' element={<PropertyDetails/>}></Route>
              </Route>
              <Route path='propertydetails' element={<PropertyDetails/>}></Route>
              <Route path='contactus' element={<Contact/>}></Route>
              <Route path='register' element={<Register/>}></Route>
              <Route path='login' element={<Login/>}></Route>
              <Route path='clendar' element={<Index/>}></Route>
            </Routes>
          <Footer/>
        </BrowserRouter>
      </LoginContext.Provider>
    </>
  );
}

export default App;
